import BillForm from './BillForm'
import BillsList from './BillsList'

const BillsContainer = ( props ) => {

    
    return (
        <div>

            <BillForm />
            
            <BillsList />
        </div>
    )
}

export default BillsContainer